import React from "react";
import {Text, Linking, TouchableOpacity} from "react-native";

class OpenUrlButton extends React.Component{
    constructor(props) {
        super(props);
    }

    async openUrl(url){
        const supported = await Linking.canOpenURL(url);

        if(supported){
            await Linking.openURL(url);
        }else {
            alert(`Don't know how to open this URL: ${url}`);
        }
    }

    render() {
        return <TouchableOpacity
            style={{display: "inline", ...(this.props.style || {})}}
            onPress={()=>{this.openUrl(this.props.url)}}>
            <Text style={{textDecoration: "underline"}}>{this.props.title}</Text>
        </TouchableOpacity>;
    }

}

export default OpenUrlButton;
